import {getIcon, initMap, primaryColor} from "./_maps-common.js";

let map;
let markers = {};
let infowindow;
let bounds;

window.createStravaMap = function (data) {
    if (!_.get(data, 'map.polyline')) {
        throw new Error('Wrong data format!');
    }

    [bounds, infowindow, map] = initMap();

    let decodedPath = google.maps.geometry.encoding.decodePath(data.map.polyline);

    for (let i in decodedPath) {
        bounds.extend(new google.maps.LatLng(decodedPath[i].lat(), decodedPath[i].lng()));
    }

    let border = new google.maps.Polyline({
        path: decodedPath,
        geodesic: true,
        strokeColor: primaryColor,
        strokeOpacity: 1.0,
        strokeWeight: 5
    });

    let path = new google.maps.Polyline({
        path: decodedPath,
        geodesic: true,
        strokeColor: '#FFFFFF',
        strokeOpacity: 1.0,
        strokeWeight: 3
    });

    border.setMap(map);
    path.setMap(map);

    for (let i in data.segments) {
        let segment = data.segments[i];

        addMarker({
            id: segment.id + '-start',
            lat: segment.start_latitude,
            lng: segment.start_longitude,
            title: segment.name,
            tooltip: tooltip(segment.name, 'début', segment.images.start),
            index: i
        });

        addMarker({
            id: segment.id + '-end',
            lat: segment.end_latitude,
            lng: segment.end_longitude,
            title: segment.name,
            tooltip: tooltip(segment.name, 'fin', segment.images.end),
            index: i
        });

        let path = new google.maps.Polyline({
            path: google.maps.geometry.encoding.decodePath(segment.map.polyline),
            geodesic: true,
            strokeColor: primaryColor,
            strokeOpacity: 0.8,
            strokeWeight: 5
        });

        path.setMap(map);
    }

    google.maps.event.addListener(infowindow, 'closeclick', function () {
        map.fitBounds(bounds);
    });

    map.fitBounds(bounds);
};

function tooltip(name, position, image) {
    return `<a href="${image}" data-lightbox="ec-challenge-segment" data-title="${name.replace('"', '\'')}">
        <div class="ec-challenge-map-tooltip">
            <div><h5>${name} (${position})</strong></div>
            ${image ? '<div><img src="' + image + '" class="img img-responsive"></div>' : ''} 
        </div>
    </a>`;
}

function closeInfoWindow() {
    if (infowindow) {
        infowindow.close();
    }
}

function addMarker(location) {
    markers[location.id] = new MarkerWithLabel({
        position: new google.maps.LatLng(location.lat, location.lng),
        title: location.title,
        map: map,
        icon: getIcon(),
        labelContent: location.index ? (parseInt(location.index, 10) + 1) + '' : '',
        labelClass: 'ec-marker-label'
    });

    let marker = markers[location.id];

    google.maps.event.addListener(marker, 'click', function () {
        selectMarker(marker, location.tooltip);
    });
}

function selectMarker(marker, tooltip, delay) {
    closeInfoWindow();

    setTimeout(function () {
        infowindow.setContent(tooltip);
        infowindow.open(map, marker);
    }, delay || 0);
}